const phoneTypes = [
  { value: 'DEFAULT', label: 'Default', disable: false },
  { value: 'BUSINESS', label: 'Business', disable: false },
  { value: 'MOBILE', label: 'Mobile', disable: false },
  { value: 'DDI', label: 'DDI', disable: false },
  { value: 'FAX', label: 'Fax', disable: false },
  { value: 'EXTRA', label: 'Extra', disable: false }
]

const addressTypes = [
  { value: 'PRIMARY', label: 'Primary', disable: false },
  { value: 'BILLING', label: 'Billing', disable: false },
  { value: 'SERVICE', label: 'Service', disable: false },
  { value: 'STRUCTURE', label: 'Structure', disable: false },
  { value: 'EXTRA', label: 'Extra', disable: false }
]

const emailTypes = [
  { value: 'PRIMARY', label: 'Primary', disable: false },
  { value: 'BILLING', label: 'Billing', disable: false },
  { value: 'EXTRA', label: 'Extra', disable: false }
]

export function checkAddressIsSame (address1, address2) {
  if (!address1 || !address2) {
    return false
  }

  const sameAddressLine1 = (address1.address_line_1 || '').trim().toLowerCase() === (address2.address_line_1 || '').trim().toLowerCase()
  const sameState = (address1.state || '').trim().toLowerCase() === (address2.state || '').trim().toLowerCase()
  const sameLocality = (address1.locality || '').trim().toLowerCase() === (address2.locality || '').trim().toLowerCase()
  const samePostalCode = (address1.postal_code || '').trim().toLowerCase() === (address2.postal_code || '').trim().toLowerCase()
  const sameCountry = (address1.country || '').trim().toLowerCase() === (address2.country || '').trim().toLowerCase()

  return sameAddressLine1 && sameState && sameLocality && samePostalCode && sameCountry
}

export function getFullAddressStr (address, withLines = false) {
  if (!address) {
    return null
  }

  const line1 = (address.address_line_1 || '').trim()
  let line2 = ''
  if (address.locality) {
    line2 += address.locality + ' '
  }

  if (address.state) {
    line2 += address.state + ' '
  }

  if (address.postal_code) {
    line2 += address.postal_code + ' '
  }

  if (address.country) {
    if (line2.trim().length > 0) {
      line2 = line2.trim()
      line2 += ', '
    }

    line2 += address.country
  }

  line2 = line2.trim()

  // Print address as extended mutliline string
  if (withLines) {
    let line = ''
    if (line1.length > 0) {
      line += line1
      if (line2.length > 0) {
        line += '\n'
      }
    }
    line += line2
    return line.trim()
  }

  const delim = line1.length > 0 && line2.length > 0 ? ',' : ''

  return ((line1 + delim + ' ' + line2).trim()) || null
}

export function getFullPhoneStr (phone) {
  if (!phone) {
    return null
  }

  let str = ''
  if (phone.country_code) {
    str += '+' + phone.country_code + ' '
  }
  if (phone.area_code) {
    str += phone.area_code + ' '
  }
  if (phone.phone_number) {
    str += phone.phone_number
  }
  return str.length > 0 ? str : null
}

export function getAddressPayload (allKeys = false, prefill = {}) {
  const obj = {
    latitude: prefill.latitude || null,
    longitude: prefill.longitude || null,
    address_line_1: prefill.address_line_1 || null,
    state: prefill.state || null,
    locality: prefill.locality || null,
    postal_code: prefill.postal_code || null,
    country: prefill.country || null
  }
  if (allKeys) {
    obj.note = null
    obj.type = prefill.type || null
    obj.field_name = prefill.field_name || null
  }
  return obj
}

export function getPhonePayload (allKeys = false, prefill = {}) {
  const obj = {
    area_code: prefill.area_code || null,
    country_code: prefill.country_code || null,
    phone_number: prefill.phone_number || null
  }
  if (allKeys) {
    obj.type = prefill.type || null
    obj.field_name = prefill.field_name || null
  }
  return obj
}

export function getEmailPayload (allKeys = false, prefill = {}) {
  const obj = {
    email_address: prefill.email_address || null
  }
  if (allKeys) {
    obj.type = prefill.type || null
    obj.field_name = prefill.field_name || null
  }
  return obj
}

// Find the first available address in specific order of priority
export function findAddress (addresses = [], ...order) {
  for (const ele of order) {
    const address = addresses.find(item => item.type === ele)
    if (address) {
      return address
    }
  }
  return null
}

// Find the first phone number in specific order of priority
export function findPhone (phones = [], ...order) {
  for (const ele of order) {
    const phone = phones.find(item => item.type === ele)
    if (phone) {
      return phone
    }
  }
  return null
}

export function findEmail (emails = [], ...order) {
  for (const ele of order) {
    const email = emails.find(item => item.type === ele)
    if (email) {
      return email
    }
  }
  return null
}

export default {
  data () {
    return {
      phoneTypes,
      addressTypes,
      emailTypes
    }
  },
  methods: {
    getAddressPayload,
    getPhonePayload,
    getEmailPayload,
    findAddress,
    findPhone,
    findEmail
  }
}
